module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.38861cba61c66739c145.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module id = ../../../../../src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.ttf
// module chunks = styles